import {RealtimeEventType} from '@sollapay/enums';
import {useQueryClient} from '@tanstack/react-query';

import {useRealtimeEvent} from '@/hooks/useRealtimeEvent';

import {documentKeys, documentProcessingKeys} from '.';

export function useDocumentRealtimeUpdates(): void {
  const queryClient = useQueryClient();

  useRealtimeEvent(RealtimeEventType.DocumentProcessingChanged, event => {
    void queryClient.invalidateQueries({
      queryKey: documentProcessingKeys.byDocument(event.documentId)
    });
    void queryClient.invalidateQueries({
      queryKey: documentKeys.all(event.entityType, event.entityId)
    });
  });
}
